module.exports = __webpack_public_path__ + "img/arrow-up.e8c4b8b3.png";